import { useDispatch, useSelector } from "react-redux";
// @ts-expect-error: ignoring as it is existing js file
import { getCommissionReport, userSelector } from "@/store/slices/userSlice";
import { IDispatchResponse, ReportExportPayload } from "@/utils/interface";
import { UserSlice, UserState } from "@/store/slices/types/userSlice";
import { openSnackbar } from "@/store/slices/snackbarSlice";
import { buildReportRequestBody, getToastErrorMessage, getToastSuccessMessage } from "@/utils/commonFunctions";
import DateRangeExportPanel from "../components/DateRangeExportPanel";

const getDefaultReportEmail = (email: UserState["email"]) => {
  return typeof email === "string" ? email : (email?.address ?? "");
};

const CommissionReport = () => {
  const dispatch = useDispatch();
  const { commissionReportLoader, email } = useSelector<UserSlice, UserState>(userSelector);

  const handleExport = (payload: ReportExportPayload) => {
    return dispatch(
      getCommissionReport({
        data: buildReportRequestBody(payload),
      }),
    ).then((res: IDispatchResponse) => {
      if (res.error) {
        dispatch(openSnackbar({ message: getToastErrorMessage(res, "Error in exporting report"), intent: "danger" }));
        return false;
      }

      dispatch(
        openSnackbar({
          message: getToastSuccessMessage(res, "Report request submitted. We will email it when it is ready."),
          intent: "success",
        }),
      );

      return true;
    });
  };

  return (
    <DateRangeExportPanel
      title="Send commission report by email"
      description="Choose the date range you want included in the commission report, then send the filtered data by email."
      loading={commissionReportLoader}
      onExport={handleExport}
      defaultEmail={getDefaultReportEmail(email)}
    />
  );
};

export default CommissionReport;
